import React, { useState } from "react";
import { func, object } from "prop-types";
import { register } from "@quintype/bridgekeeper-js";
import { isValidEmail } from "../../utils";

import "./forms.m.css";

const CreateAnAccount = ({ setActiveTab, onSignup, userInfo, setUserInfo, setLoading }) => {
  const [error, setError] = useState("");

  const trackSignupEvent = (action) => {
    if (typeof window !== "undefined" && window.dataLayer) {
      window.dataLayer.push({
        event: "dl_signup_steps",
        event_action: action,
      });
    }
  };

  const trackRegistrationEvent = ({ action, errorMessage }) => {
    if (typeof window !== "undefined" && window.dataLayer) {
      window.dataLayer.push({
        event: "dl_signup_error",
        event_action: action,
        error_message: errorMessage,
      });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!isValidEmail(userInfo.email)) {
      setError("Please enter a valid email address");
      return;
    }

    try {
      const userObj = {
        username: userInfo.email,
        name: userInfo.email,
        email: userInfo.email,
        password: userInfo.password,
      };
      setLoading(true);
      trackSignupEvent("password_submit");

      const response = await register(userObj);

      if (response.user) {
        await onSignup(response.user);
      } else {
        setError("Registration failed");
        console.error("Registration failed", response);
        trackRegistrationEvent({ action: "password_submit", errorMessage: "Registration failed" });
      }
    } catch (error) {
      console.error("Registration failed", error);
      trackRegistrationEvent({ action: "password_submit", errorMessage: "Registration failed" });
    } finally {
      setLoading(false);
    }
  };
  const setData = (e) => {
    const userObj = { ...userInfo };
    const fieldName = e.target.id;
    userObj[fieldName] = e.target.value;
    setUserInfo(userObj);
  };

  return (
    <div styleName="auth-container signup-container">
      <h2 styleName="auth-title">Create an Account</h2>
      <p>
        Already have an account?{" "}
        <a href="#" onClick={() => setActiveTab("landing")}>
          Sign In
        </a>
      </p>
      <form onSubmit={handleSubmit}>
        <label htmlFor="email" styleName="auth-label">
          Enter Email
        </label>
        <input
          type="email"
          id="email"
          name="email"
          value={userInfo.email}
          onChange={setData}
          onFocus={() => setError("")}
          placeholder="Enter your email"
          required
          styleName="auth-input"
        />

        <label htmlFor="password" styleName="auth-label">
          Create Password
        </label>
        <input
          type="password"
          id="password"
          name="password"
          value={userInfo.password}
          onChange={setData}
          placeholder="Enter your password"
          required
          styleName="auth-input"
        />

        {error && <p styleName="error">{error}</p>}

        <button type="submit" styleName="submit-button">
          Continue
        </button>
      </form>
    </div>
  );
};

CreateAnAccount.propTypes = {
  setActiveTab: func,
  userInfo: object,
  setUserInfo: func,
  onSignup: func,
  setLoading: func,
};

export { CreateAnAccount };
